import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountTag',
  props: {
  isMain: { type: Boolean, default: false },
  textOnly: { type: Boolean, default: false },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const main = computed(() => t('modules.accounts.typeTag.main'));
const sub = computed(() => t('modules.accounts.typeTag.sub'));

__expose({
  props,
  main,
  sub,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['account-tag', __props.isMain ? 'account-tag--main' : 'account-tag--sub', { 'account-tag--text-only': __props.textOnly }])
  }, _toDisplayString(__props.isMain ? main.value : sub.value), 3))
}
}

})